import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Avatar from '~/components/views/Avatar/Avatar';
import type { AppState } from '~/reducers';
import * as S from './styled';

export interface StateProps {
  onlyAvatar?: boolean;
  open?: boolean;
  testidOpen?: string;
  testIdClosed?: string;
}

const UserProfileMenuHeader = ({
  onlyAvatar = false,
  open = false,
  testidOpen = 'avatar-menu-icon-open',
  testIdClosed = 'avatar-menu-icon-closed',
}: StateProps) => {
  const { firstName, lastName, name } = useSelector((state: AppState) => state.authentication);

  const initials = useMemo(() => {
    return `${firstName?.substring(0, 1)}${lastName?.substring(0, 1)}`;
  }, [firstName, lastName]);

  if (onlyAvatar) {
    return (
      <S.OnlyAvatarWrapper data-testid={open ? testidOpen : testIdClosed}>
        <Avatar text={initials} size="small"></Avatar>
      </S.OnlyAvatarWrapper>
    );
  }

  return (
    <S.MenuHeaderWrapper>
      <Avatar text={initials} size="small"></Avatar>
      <S.Heading>{name}</S.Heading>
    </S.MenuHeaderWrapper>
  );
};

export default UserProfileMenuHeader;
